import React, { useMemo, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import "./DashboardRegulatedScatter.scss";
import RegulatedScatterChart from "../DataEstate/DataEstateCards/RegulatedScatterChart";

const CLASSIFICATION_COLORS = {
  PCI_DSS: "#e74c3c",
  PII: "#3498db",
  GDPR: "#9b59b6",
  Confidential: "#27ae60",
  Financial: "#f1c40f",
  "PHI/HIPAA": "#16a085",
};

const INACTIVE_COLOR = "#9ca3af";

export default function DashboardRegulatedScatter({
  data,
  expanded = false,
  onClose,
}) {
  const [activeFilter, setActiveFilter] = useState(null);


  const filters = useMemo(() => {
    const set = new Set();
    Object.keys(data || {}).forEach((k) =>
      k.split(",").forEach((c) => set.add(c))
    );
    return Array.from(set);
  }, [data]);

  const toggleFilter = (type) => {
    setActiveFilter((prev) => (prev === type ? null : type));
  };

  return (
    <div className={`dashboard-regulated ${expanded ? "is-expanded" : ""}`}>
      <div className="dr-content">
        <RegulatedScatterChart
          data={data}
          expanded={expanded}
          activeFilter={activeFilter}
        />

        <div className="ss-filters">
          {filters.map((type) => {
            const active = activeFilter === type;
            return (
              <div
                key={type}
                className={`ss-filter ${active ? "active" : ""}`}
                style={{ "--filter-color": CLASSIFICATION_COLORS[type] }}
                onClick={() => toggleFilter(type)}
              >
                {type}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
